import React from 'react';
import { useAnalytics } from '@/hooks/useAnalytics';

// Provider component that initializes analytics tracking
export const AnalyticsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // This will automatically track page views and scroll events
  useAnalytics();
  
  return <>{children}</>;
};

// HOC to add analytics tracking to forms
export const withFormAnalytics = <T extends {}>(
  WrappedComponent: React.ComponentType<T>,
  formName: string
) => {
  return (props: T) => {
    const { trackFormOpen, trackFormSubmit } = useAnalytics();

    React.useEffect(() => {
      // Track form open when component mounts
      trackFormOpen(formName);
    }, []);

    return <WrappedComponent {...props} onSubmit={(e: any) => {
      trackFormSubmit(formName);
      if ((props as any).onSubmit) {
        (props as any).onSubmit(e);
      }
    }} />;
  };
};

// HOC to add analytics tracking to buttons and links
export const withClickAnalytics = <T extends Record<string, any>>(
  WrappedComponent: React.ComponentType<T>
) => {
  return (props: T) => {
    const { trackClick, trackSocialClick } = useAnalytics();

    const handleClick = (e: React.MouseEvent) => {
      const target = e.currentTarget as HTMLElement;
      const elementType = target.tagName.toLowerCase();
      const elementId = target.id;
      const elementText = target.textContent;
      const href = target.getAttribute('href');

      // Check if it's a social media link
      if (href && (href.includes('twitter.com') || href.includes('instagram.com') || href.includes('linkedin.com') || href.includes('facebook.com'))) {
        const platform = href.includes('twitter') ? 'twitter' : 
                        href.includes('instagram') ? 'instagram' :
                        href.includes('linkedin') ? 'linkedin' : 
                        href.includes('facebook') ? 'facebook' : 'other';
        trackSocialClick(platform, href);
      } else {
        trackClick(elementType, elementId, elementText);
      }

      if (props.onClick) {
        props.onClick(e);
      }
    };

    return <WrappedComponent {...props} onClick={handleClick} />;
  };
};